export default class VideoPopup {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            let shown_videos = [];

            $('.video-popup, .wistia-video:not(.wistia-container__video)').on('click', function (e){
                e.preventDefault();
                let video = $(this).attr('data-src');
                let video_url = video;
                let form = $(this).attr('data-form');

                if(video){

                    if (video.includes('youtube.com') || video.includes('youtu.be')) {
                        let youtubeId = video.split('v=')[1]?.split('&')[0] || video.split('/').pop();

                        let params = video.split('v=')[1]?.split('&').slice(1).join('&') || "";

                        let embedUrl = `https://www.youtube.com/embed/${youtubeId}`;
                        if (params) {
                            embedUrl += `?${params}`;
                        }

                        video = embedUrl;
                    }else if (video.includes('info.duckcreek.com')) {} else {
                        video = 'https://fast.wistia.net/embed/iframe/' + (video.split('medias/')[1] || video.split('medias/')[0]);
                    }
                    $('.popup-wistia').addClass('active');

                    if (shown_videos.includes(video)) {
                        form = '';
                    }

                    if(form) {
                        document.cookie = "YOUR_COOKIE_NAME=; domain=.get.duckcreek.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";

                        const iframe_html = '<iframe id="pardotFormIframe" class="mfp-form" src="' + form + '" frameborder="0" allowfullscreen></iframe>';

                        $('.popup-wistia__iframe').html(iframe_html);

                        setTimeout(function () {

                            const iframe = document.querySelector("#pardotFormIframe");

                            iframe.onload = () => {
                                iframe.contentWindow.postMessage({ type: "setVideoUrl", value: video, event: "" }, "*");
                            };

                            window.addEventListener("message", function(event) {
                                $('.popup-wistia__iframe #pardotFormIframe').remove();
                                if (event.data.event === "showVideo") {
                                    const videoIframe = '<iframe class="mfp-iframe" src="' + video + '" width="100%" height="750" type="text/html" frameborder="0" allowTransparency="true" style="border: 0"></iframe>';
                                    if (!shown_videos.includes(video)) {
                                        shown_videos.push(video);

                                        var ajaxurl = '/wp-admin/admin-ajax.php';
                                        $.ajax({
                                            type: "POST",
                                            url: ajaxurl,
                                            data: {
                                                action: "save_submitted_video",
                                                video_url: video_url
                                            },
                                            success: function(response) {
                                            },
                                            error: function(err) {
                                            }
                                        });

                                    }

                                    $('.popup-wistia__iframe #pardotFormIframe').remove();
                                    $('.popup-wistia__iframe').html(videoIframe);
                                }
                            });

                        }, 300);

                    } else {
                        $('.popup-wistia__iframe').html('<iframe class="mfp-iframe" src="' + video + '" frameborder="0" allowfullscreen></iframe>');
                    }
                }
            })

            $('.popup-wistia__exit, .popup-wistia .rgba').on('click', function (e){
                e.preventDefault();
                $('.popup-wistia').removeClass('active');
                $('.popup-wistia__iframe').html('');
            })
        })
    }

}